import { render, staticRenderFns } from "./TransformIntro.vue?vue&type=template&id=af5b1e40&scoped=true&"
import script from "./TransformIntro.vue?vue&type=script&lang=js&"
export * from "./TransformIntro.vue?vue&type=script&lang=js&"
import style0 from "./TransformIntro.vue?vue&type=style&index=0&id=af5b1e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5b1e40",
  null
  
)

export default component.exports